import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_enter_order_details = _resolveComponent("enter-order-details")
  const _component_unsupported_country = _resolveComponent("unsupported-country")
  const _component_return_entire_order = _resolveComponent("return-entire-order")
  const _component_return_entire_order_summary = _resolveComponent("return-entire-order-summary")
  const _component_return_entire_order_confirmation = _resolveComponent("return-entire-order-confirmation")
  const _component_select_items_to_return = _resolveComponent("select-items-to-return")
  const _component_return_summary = _resolveComponent("return-summary")
  const _component_return_confirmation = _resolveComponent("return-confirmation")
  const _component_return_success = _resolveComponent("return-success")
  const _component_return_modal = _resolveComponent("return-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: `page-${$data.sideToSlideTo}`,
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        ($data.currentPage === 'ENTER_ORDER_DETAILS')
          ? (_openBlock(), _createBlock(_component_enter_order_details, {
              key: 0,
              onOrderFetched: $options.handleOrderFetched
            }, null, 8, ["onOrderFetched"]))
          : ($data.currentPage === 'UNSUPPORTED_COUNTRY')
            ? (_openBlock(), _createBlock(_component_unsupported_country, { key: 1 }))
            : ($data.currentPage === 'RETURN_ENTIRE_ORDER')
              ? (_openBlock(), _createBlock(_component_return_entire_order, {
                  key: 2,
                  order: $data.order,
                  reason: $data.reason,
                  "items-dropdown-status": $data.itemsDropdownStatus,
                  onUpdateModal: $options.updateModal,
                  onNavigate: $options.navigate,
                  onToggleItemsDropdown: $options.toggleItemsDropdownState
                }, null, 8, ["order", "reason", "items-dropdown-status", "onUpdateModal", "onNavigate", "onToggleItemsDropdown"]))
              : ($data.currentPage === 'RETURN_ENTIRE_ORDER_SUMMARY')
                ? (_openBlock(), _createBlock(_component_return_entire_order_summary, {
                    key: 3,
                    order: $data.order,
                    reason: $data.reason,
                    "items-dropdown-status": $data.itemsDropdownStatus,
                    onNavigate: $options.navigate,
                    onToggleItemsDropdown: $options.toggleItemsDropdownState
                  }, null, 8, ["order", "reason", "items-dropdown-status", "onNavigate", "onToggleItemsDropdown"]))
                : ($data.currentPage === 'RETURN_ENTIRE_ORDER_CONFIRMATION')
                  ? (_openBlock(), _createBlock(_component_return_entire_order_confirmation, {
                      key: 4,
                      order: $data.order,
                      reason: $data.reason,
                      "items-dropdown-status": $data.itemsDropdownStatus,
                      onUpdateModal: $options.updateModal,
                      onNavigate: $options.navigate,
                      onToggleItemsDropdown: $options.toggleItemsDropdownState
                    }, null, 8, ["order", "reason", "items-dropdown-status", "onUpdateModal", "onNavigate", "onToggleItemsDropdown"]))
                  : ($data.currentPage === 'SELECT_ITEMS_TO_RETURN')
                    ? (_openBlock(), _createBlock(_component_select_items_to_return, {
                        key: 5,
                        order: $data.order,
                        "reason-options": $props.reasonOptions,
                        "items-to-return": $data.itemsToReturn,
                        "items-dropdown-status": $data.itemsDropdownStatus,
                        onItemsToReturnSelected: $options.setItemsToReturn,
                        onUpdateModal: $options.updateModal,
                        onNavigate: $options.navigate,
                        onToggleItemsDropdown: $options.toggleItemsDropdownState
                      }, null, 8, ["order", "reason-options", "items-to-return", "items-dropdown-status", "onItemsToReturnSelected", "onUpdateModal", "onNavigate", "onToggleItemsDropdown"]))
                    : ($data.currentPage === 'RETURN_SUMMARY')
                      ? (_openBlock(), _createBlock(_component_return_summary, {
                          key: 6,
                          "items-to-return": $data.itemsToReturn,
                          "items-dropdown-status": $data.itemsDropdownStatus,
                          onNavigate: $options.navigate,
                          onToggleItemsDropdown: $options.toggleItemsDropdownState
                        }, null, 8, ["items-to-return", "items-dropdown-status", "onNavigate", "onToggleItemsDropdown"]))
                      : ($data.currentPage === 'RETURN_CONFIRMATION')
                        ? (_openBlock(), _createBlock(_component_return_confirmation, {
                            key: 7,
                            "items-to-return": $data.itemsToReturn,
                            order: $data.order,
                            "items-dropdown-status": $data.itemsDropdownStatus,
                            onUpdateModal: $options.updateModal,
                            onNavigate: $options.navigate,
                            onToggleItemsDropdown: $options.toggleItemsDropdownState
                          }, null, 8, ["items-to-return", "order", "items-dropdown-status", "onUpdateModal", "onNavigate", "onToggleItemsDropdown"]))
                        : ($data.currentPage === 'RETURN_SUCCESS')
                          ? (_openBlock(), _createBlock(_component_return_success, { key: 8 }))
                          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name"]),
    _createVNode(_component_return_modal, {
      status: $data.modalStatus,
      type: $data.modalType,
      "reason-options": $props.reasonOptions,
      onReasonSelected: $options.handleReasonSelected,
      onUpdateModal: $options.updateModal,
      onNavigate: $options.navigate
    }, null, 8, ["status", "type", "reason-options", "onReasonSelected", "onUpdateModal", "onNavigate"])
  ], 64))
}